<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <router-link class="sidebar-logo-link" to="/">
      <span class="logo-text">{{ collapse ? '51' : '51gp' }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.sidebar-logo-container {
  width: 100%;
  height: 64px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  box-sizing: border-box;

  &.collapse {
    padding: 0;
    justify-content: center;
  }

  .sidebar-logo-link {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .logo-text {
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.5px;
    line-height: 1;
  }

  &.collapse .logo-text {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/admin/layout/components/Sidebar/Logo.vue